"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../../shared"));

var _Button = _interopRequireDefault(require("../../Button/Button"));

var _UserNavItem = _interopRequireDefault(require("./UserNavItem"));

require("./UserNav.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
wrapper for single clickable user navigation item
*/
function UserNavLink(_ref) {
  var className = _ref.className,
      componentEl = _ref.componentEl,
      icon = _ref.icon,
      children = _ref.children,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "componentEl", "icon", "children"]);

  var buttonProps = {
    tertiary: true,
    fullWidth: true,
    icon: icon,
    className: className
  };
  if (componentEl) buttonProps.componentEl = componentEl;
  return /*#__PURE__*/_react["default"].createElement(_UserNavItem["default"], {
    padding: {
      vertical: 'smd',
      horizontal: 'smd'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({}, buttonProps, otherProps), children));
}

UserNavLink.propTypes = {
  /** extra CSS classes, if any, for Button component */
  className: utils.classNames.classNameProps,

  /** dom element or component to use for Button component */
  componentEl: utils.componentEl.props,

  /** optional icon for menu item */
  icon: _propTypes["default"].string
};
UserNavLink.defaultProps = {
  className: null,
  componentEl: null,
  icon: null
};
UserNavLink.displayName = 'HeaderBar.User.Link';
var _default = UserNavLink;
exports["default"] = _default;